import React from "react";

interface IProps {
	pcode: string;
	message: string;

	onClose: (e: React.MouseEvent) => void;
}

/**
 * Generic message modal.
 * Usage: Bet error/bet closed notice
 */
export default class MessageModal extends React.Component<IProps> {
	render() {
		const
			{ message, onClose, pcode } = this.props,
			pcodeProp = { pcode },
			isBetClosed = message.toLowerCase().includes("bet closed");

		return (
			<div className="modal-container">
				<div className="betmodal-status-false">
					<div style={isBetClosed ? { "color": "#e04f4b" } : null}>
						{message}
					</div>

					<button {...pcodeProp} onClick={onClose}>
						OK
					</button>
				</div>
			</div>
		);
	}
}
